// src/services/tokenService.ts
export class TokenService {
  private static ACCESS_TOKEN_KEY = 'token';
  private static REFRESH_TOKEN_KEY = 'refreshToken';
  private static DEVICE_ID_KEY = 'deviceId';
  private static USER_KEY = 'user';

  // Access Token
  static getAccessToken(): string | null {
    return localStorage.getItem(this.ACCESS_TOKEN_KEY);
  }

  static setAccessToken(token: string): void {
    localStorage.setItem(this.ACCESS_TOKEN_KEY, token);
  }

  // Refresh Token
  static getRefreshToken(): string | null {
    return localStorage.getItem(this.REFRESH_TOKEN_KEY);
  }

  static setRefreshToken(token: string): void {
    localStorage.setItem(this.REFRESH_TOKEN_KEY, token);
  }

  // Device ID
  static getDeviceId(): string | null {
    return localStorage.getItem(this.DEVICE_ID_KEY);
  }

  static setDeviceId(deviceId: string): void {
    localStorage.setItem(this.DEVICE_ID_KEY, deviceId);
  }

  // User
  static getUser(): any | null {
    const userData = localStorage.getItem(this.USER_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  static setUser(user: any): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
  }

  // Check if token is expired
  static isTokenExpired(token: string): boolean {
    if (!token) return true;

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const currentTime = Date.now() / 1000;
      return payload.exp < currentTime;
    } catch (error) {
      return true;
    }
  }

  // Clear all data
  static clearAll(): void {
    localStorage.removeItem(this.ACCESS_TOKEN_KEY);
    localStorage.removeItem(this.REFRESH_TOKEN_KEY);
    localStorage.removeItem(this.DEVICE_ID_KEY);
    localStorage.removeItem(this.USER_KEY);
    localStorage.removeItem('email');
    localStorage.removeItem('rememberMe');
  }

  // Update tokens from login response
  static updateTokens(data: any): void {
    if (data.tokens) {
      if (data.tokens.accessToken) {
        this.setAccessToken(data.tokens.accessToken);
      }
      if (data.tokens.refreshToken) {
        this.setRefreshToken(data.tokens.refreshToken);
      }
      if (data.tokens.deviceId) {
        this.setDeviceId(data.tokens.deviceId);
      }
    }
    if (data.user) {
      this.setUser(data.user);
    }
  }
}
